import api from './api';

export const employeeService = {
  getEmployees: async (params = {}) => {
    const response = await api.get('/employees', { params });
    return response.data;
  },

  getEmployeeById: async (id) => {
    const response = await api.get(`/employees/${id}`);
    return response.data;
  },

  createEmployee: async (data) => {
    const response = await api.post('/employees', data);
    return response.data;
  },

  updateEmployee: async (id, data, reAuthToken = null) => {
    const config = reAuthToken ? { headers: { 'X-Reauth-Token': reAuthToken } } : undefined;
    const response = await api.put(`/employees/${id}`, data, config);
    return response.data;
  },

  updateStatus: async (id, isActive) => {
    const response = await api.patch(`/employees/${id}/status`, { isActive });
    return response.data;
  },

  unlockAccount: async (id) => {
    const response = await api.post(`/employees/${id}/unlock`);
    return response.data;
  },

  checkUsername: async (username, excludeId = null) => {
    const response = await api.get('/employees/check-username', {
      params: { username, excludeId },
    });
    return response.data;
  },

  getRolesLookup: async () => {
    const response = await api.get('/employees/lookup/roles');
    return response.data;
  },

  getCentresLookup: async () => {
    const response = await api.get('/employees/lookup/centres');
    return response.data;
  },

  getDepartmentsLookup: async () => {
    const response = await api.get('/employees/lookup/departments');
    return response.data;
  },

  getDesignationsLookup: async () => {
    const response = await api.get('/employees/lookup/designations');
    return response.data;
  },

  getUserWorkspaces: async (employeeId) => {
    const response = await api.get(`/permissions/user-workspaces/${employeeId}`);
    return response.data;
  },

  saveUserWorkspaces: async (employeeId, workspaces) => {
    const response = await api.post(`/permissions/user-workspaces/${employeeId}`, { workspaces });
    return response.data;
  },

  getAccessConfig: async (employeeId) => {
    const response = await api.get(`/employee-access/${employeeId}`);
    return response.data;
  },

  saveAccessConfig: async (employeeId, data) => {
    const response = await api.put(`/employee-access/${employeeId}`, data);
    return response.data;
  },

  getActiveSessions: async (employeeId) => {
    const response = await api.get(`/employee-access/${employeeId}/sessions`);
    return response.data;
  },

  forceLogoutSession: async (sessionId, reason = 'Terminated by administrator') => {
    const response = await api.post(`/employee-access/sessions/${sessionId}/force-logout`, { reason });
    return response.data;
  },

  logoutAllSessions: async (employeeId, reason = 'Terminated all sessions by administrator') => {
    const response = await api.post(`/employee-access/${employeeId}/logout-all`, { reason });
    return response.data;
  },
};

export default employeeService;
